import React, { useEffect } from 'react';
import './Loader.scss';

const Loader = ({ onFinish }) => {
    useEffect(() => {
        const removeTimer = setTimeout(() => {
            if (onFinish) onFinish();
        }, 2000); // in css
        return () => {
            clearTimeout(removeTimer);
        };
    }, [onFinish]);

    return (
        <div className="loader-overlay">
            <img src="/content/nthng_loading_logo_75.gif" alt="Loading..." className="loader-gif" width={75} height={75} />
        </div>
    );
};

export default Loader;